import React from 'react';
import Section from './Section';
import { siteData } from '../data/site';
import empatia from '../assets/empatia.png';
import excelencia from '../assets/excelencia.png';
import familia from '../assets/familia.png';
import innovacion from '../assets/innovacion.png';

const ABOUT_IMG =
  'https://image.pollinations.ai/prompt/Warm%20friendly%20illustration%20of%20diverse%20children%20playing%20and%20learning%20in%20therapy%20session%2C%20speech%20therapy%20and%20occupational%20therapy%2C%20soft%20pastel%20colors%20pink%20coral%20blue%20lavender%2C%20watercolor%20style%2C%20professional%20pediatric%20clinic%20atmosphere%2C%20kite%20flying%20motif%2C%20joyful%20children%20aged%202-10%2C%20no%20text%2C%20square%20format?model=flux&seed=190310&width=800&height=800';

const AboutFallback =
  'https://images.unsplash.com/photo-1503454537195-1dcabb73ffb9?w=800&q=80';

const valores = [
  {
    img: empatia,
    title: 'Empatía',
    desc: 'Ponemos el corazón en cada atención',
    bg: 'bg-pink-50',
    accent: 'border-pink-200',
  },
  {
    img: excelencia,
    title: 'Excelencia',
    desc: 'Buscamos la mejor calidad en todo',
    bg: 'bg-violet-50',
    accent: 'border-violet-200',
  },
  {
    img: familia,
    title: 'Familia',
    desc: 'Trabajamos con toda la familia',
    bg: 'bg-sky-50',
    accent: 'border-sky-200',
  },
  {
    img: innovacion,
    title: 'Innovación',
    desc: 'Utilizamos las mejores técnicas',
    bg: 'bg-emerald-50',
    accent: 'border-emerald-200',
  },
];

const CheckIcon = () => (
  <svg className="w-5 h-5 text-primary flex-shrink-0" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2.5}>
    <path strokeLinecap="round" strokeLinejoin="round" d="M4.5 12.75l6 6 9-13.5" />
  </svg>
);

const About = () => {
  return (
    <Section id="quienes-somos" className="bg-gradient-to-b from-white to-[#fdf6ff]">

      {/* Header */}
      <div className="text-center mb-16">
        <span className="badge bg-secondary/40 text-text mb-4">Nuestro centro</span>
        <h2 className="section-title mb-4">Quiénes Somos</h2>
        <p className="section-subtitle">
          Somos un equipo de profesionales mujeres especializadas en el desarrollo de niños y preadolescentes,
          comprometidas con el bienestar integral de cada niño y su familia.
        </p>
      </div>

      {/* Main content: image + text */}
      <div className="grid lg:grid-cols-2 gap-12 lg:gap-16 items-center mb-20">

        {/* Image */}
        <div className="relative order-2 lg:order-1">
          <div className="absolute inset-0 bg-gradient-to-br from-background/60 to-secondary/40 rounded-[2.5rem] -rotate-2 scale-105" />
          <img
            src={ABOUT_IMG}
            alt="Niños jugando en terapia"
            className="relative z-10 w-full rounded-[2rem] shadow-xl object-cover aspect-square"
            onError={(e) => {
              e.currentTarget.onerror = null;
              e.currentTarget.src = AboutFallback;
            }}
          />
          {/* Floating stat */}
          <div className="absolute z-20 -bottom-5 -right-4 bg-white rounded-2xl shadow-xl px-5 py-3 border border-gray-100">
            <p className="font-fredoka text-3xl text-primary leading-none">+15</p>
            <p className="text-xs text-text/60 font-nunito">Servicios disponibles</p>
          </div>
        </div>

        {/* Text */}
        <div className="space-y-8 order-1 lg:order-2">
          <div className="space-y-6">
            <div className="bg-white rounded-3xl p-6 shadow-md border border-primary/10">
              <h3 className="font-fredoka text-2xl text-primary mb-3">Nuestra Visión</h3>
              <p className="text-text/75 leading-relaxed">{siteData.vision}</p>
            </div>
            <div className="bg-white rounded-3xl p-6 shadow-md border border-secondary/30">
              <h3 className="font-fredoka text-2xl text-text mb-3">Nuestra Misión</h3>
              <p className="text-text/75 leading-relaxed">{siteData.mission}</p>
            </div>
          </div>

          {/* Key points */}
          <div className="space-y-3">
            {[
              'Profesionales especializadas en desarrollo infantil',
              'Evaluaciones y terapias basadas en evidencia',
              'Acompañamiento integral a toda la familia',
              'Modalidades presencial, online y a domicilio',
            ].map((point) => (
              <div key={point} className="flex items-start gap-3">
                <CheckIcon />
                <span className="text-text/75 text-sm leading-relaxed">{point}</span>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Valores */}
      <div>
        <h3 className="font-fredoka text-3xl text-text text-center mb-10">Nuestros Valores</h3>
        <div className="grid grid-cols-2 md:grid-cols-4 gap-5">
          {valores.map((valor) => (
            <div
              key={valor.title}
              className={`group ${valor.bg} border-2 ${valor.accent} rounded-3xl p-6 text-center space-y-4 hover:shadow-lg transition-all duration-300 cursor-default`}
            >
              <div className="group-hover:scale-110 transition-transform duration-300">
                <img
                  src={valor.img}
                  alt={valor.title}
                  className="mx-auto w-16 h-16 object-contain"
                />
              </div>
              <h4 className="font-fredoka text-xl text-text">{valor.title}</h4>
              <p className="text-sm text-text/65 font-nunito leading-snug">{valor.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </Section>
  );
};

export default About;
